import React from 'react';
import DateRangeBox from 'devextreme-react/date-range-box';

const DateRange = ({ onDateChange, dateRange}) => {
  const dateRangeString = dateRange || ''; // Ensure it's always a string
  const parsedDateRange = dateRangeString ? dateRangeString.split(' - ') : ['', '']; 

  return (
    <DateRangeBox
      value={parsedDateRange}
      onValueChanged={(e) => {

        if (e.value?.length === 2) {
          
          onDateChange(e.value.join(' - '));

        }
        
        
      }}
      applyButtonText="Apply"
      cancelButtonText="Cancel"
      showClearButton={false}
      labelMode="hidden"
    />
  );
};



export default DateRange;
